<template>
    <div class="section01">
        <h3>교통정보</h3>
        <div class="traffic-box-wrap">
            <div class="box-wrap">
                <div class="traffic-box">
                    <strong>{{ accidentMap['traffic'] ? accidentMap['traffic'].length : '0' }}</strong>건
                    <p>교통사고</p>
                </div>
                <div class="traffic-box">
                    <strong>{{ accidentMap['event'] ? accidentMap['event'].length : '0' }}</strong>건
                    <p>집회 및 행사</p>
                </div>
                <div class="traffic-box">
                    <strong>{{ accidentMap['construction'] ? accidentMap['construction'].length : '0' }}</strong>건
                    <p>공사</p>
                </div>
                <div class="traffic-box">
                    <strong>{{ accidentMap['cartrouble'] ? accidentMap['cartrouble'].length : '0' }}</strong>건
                    <p>차량고장</p>
                </div>
            </div>
            <button type="button" id="show-box02" class="button-box-more02"
                ref="show-accident-list-btn" @click.prevent="showMoreAccidentList(true)">목록 보기</button>
            <button type="button" id="hide-box02" class="button-box-close" style="display:none;"
                ref="hide-accident-list-btn" @click.prevent="showMoreAccidentList(false)">닫기</button>
            <ul class="list01 scroll" id="show-list02" ref="accident-list-ul">
                <template v-if="typeof accidentList !== 'undefined' && accidentList.length > 0">
                    <li v-for="accident in accidentList" :key="accident.amnDataSqno">
                        <a href="#" @click.prevent="selectAccident(accident)">
                            <span class="label-box01-blue">{{ accident.accidentCategoryNm }}</span>
                            <p class="ellipsis" style="width:60%;">{{ accident.val4 }}</p>
                            <span class="label-date floatR">{{ (accident.val5 + accident.val6) | formatDate('yyyy-MM-dd HH:mm') }}</span>
                        </a>
                    </li>
                </template>
                <template v-else>
                    <li class="no-comment">
                        현재 발생 건이 없습니다.
                    </li>
                </template>
            </ul>
        </div>

        <transition name="modal">
            <AccidentInfoMapWin v-if="isShowAccidentInfoMapWin" :accident-info="selectedAccidentInfo" @close-accident-info-map-win="showAccidentInfoMapWin(false)" />
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AccidentInfoMapWin from "@/views/realtime/AccidentInfoMapWin.vue";

export default {
    name: 'TrafficSummary',
    data() {
        return {
            isShowAccidentInfoMapWin: false,
            selectedAccidentInfo: {},
        };
    },
    computed: {
        ...mapGetters({
            accidentList: 'getAccidentList',
            accidentMap: 'getAccidentCategoryMap',
        }),
    },
    methods: {
        showAccidentInfoMapWin(isShow) {
            this.isShowAccidentInfoMapWin = isShow;
        },
        showMoreAccidentList(isShow) {
            if (isShow) {
                this.$refs['accident-list-ul'].style.display = "block";
				this.$refs['hide-accident-list-btn'].style.display = "";
				this.$refs['show-accident-list-btn'].style.display = "none";
            } else {
                this.$refs['accident-list-ul'].style.display = "none";
				this.$refs['hide-accident-list-btn'].style.display = "none";
				this.$refs['show-accident-list-btn'].style.display = "";
            }
        },
        selectAccident(accident) {
            this.selectedAccidentInfo = accident;
            this.showAccidentInfoMapWin(true);
        },
    },
    components: {
        AccidentInfoMapWin,
    },
}
</script>